/*
 *
 * LanguageProvider reducer
 *
 */

import { fromJS } from 'immutable';
import queryString from 'query-string';
import { KIOSK } from 'Application/constants';
import {
  LOADING_LANGUAGE,
  LOAD_UPPTACKA,
  LANGUAGE_LOADED,
  LANGUAGE_ERROR,
  COMMON_LOADED,
  LOADING_APPLICATION_SETTINGS,
  LOADING_TRANSLATIONS,
  LOADING_DATA_PROVIDER_SETTINGS,
  GLOBAL_COMMON_LOADED,
  LOADING_LOCALE,
  LOADING_PRODUCT_SERVICE,
} from './constants';

import {
  KioskIntegration
} from "@inter-ikea-gallery/integration";
import { loadingLocale } from './actions';

export const initialState = fromJS({
  language: 'en',
  country: 'gb',
  messages: {},
  pricingRules: {},
  loading: true,
  error: null,
  localizedInfo: {},
});

function languageProviderReducer(state = initialState, action) {
  switch (action.type) {
    case LOADING_LANGUAGE:
      return state.set('loading', action.loading);
    case LANGUAGE_LOADED:
      return state.set('messages', action.messages)
        .set('language', action.language)
        .set('country', action.country);
    case LANGUAGE_ERROR:
      console.error(action, action.error); // eslint-disable-line no-console
      return state.set('error', action.error);
    case COMMON_LOADED:
      return state
        .set('alternativeLanguages', (action.common.localisation.alternateLanguages || '')
          .replace(/;$/, '')
          .split(';')
          .map((language) => language.split(':')))
        .set('locale', action.common.localisation.locale.replace('_', '-')) // IntlProvider needs format like en-GB, common provides en_GB
        .set('localizedInfo', action.common)
        .set('pricingRules', action.common.localisation)
        .set('ecoLinkURL', checkUrlLink(action.common, 'ecoLinkURL'))
        .set('hasEcoPart', action.common.localisation.hasEcoPart);
    case LOADING_APPLICATION_SETTINGS:
      return state.set('applicationSettings', action.applicationSettings);
    case LOADING_PRODUCT_SERVICE:
      return state.set('productService', action.productService);
    case LOADING_TRANSLATIONS:
      return state.set('translations', action.translations);
    case LOADING_LOCALE:
      return state.set('myLocale', loadingLocale(action.country, action.language));
    case LOADING_DATA_PROVIDER_SETTINGS:
      return state.set('dataProviderSettings', loadDataProviderSettings(action.country, action.language));
    case GLOBAL_COMMON_LOADED:
      return state.set('experienceGalleryBackURL', checkGalleryUrlLink(action.globalCommon));
    case LOAD_UPPTACKA:
      return state.set('upptackaIntegration', loadUpptackaSettings());
      default:
      return state;
  }
}
  
  function checkGalleryUrlLink(globalCommon){
    if (globalCommon["cwt.gallery.experienceGalleryBackURL"] && globalCommon !== null && globalCommon !== undefined && globalCommon["cwt.gallery.experienceGalleryBackURL"] !== "") {
      return globalCommon["cwt.gallery.experienceGalleryBackURL"];
    }
    return "https://www.ikea.com/addon-app/gallery/latest/";
  }


function checkUrlLink(action, globalCommon, common, url){
  if(url === "experienceGalleryBackURL"){
    if(action["cwt.gallery.experienceGalleryBackURL"] && action !== null && action !== undefined && action["cwt.gallery.experienceGalleryBackURL"] !==""){
      return common.URLs[url];
    }
  }
  if(globalCommon.URLs !== null && globalCommon.URLs !== undefined && globalCommon.URLs[url] !==""){
    return globalCommon.URLs[url];
  }
  return "https://www.ikea.com"
}

const isKiosk = (() => {
  const hash = window.location.hash;
  const { mode } = queryString.parse(hash.substring(hash.indexOf('?') + 1));
  return (mode && mode.toLowerCase() === KIOSK) ? true : false;
})();

const getKioskID = (() => {
  const hash = window.location.hash;
  const { computerId } = queryString.parse(hash.substring(hash.indexOf('?') + 1));
  return computerId;
})();

const getStoreID = (() => {
  const hash = window.location.hash;
  const { storeId } = queryString.parse(hash.substring(hash.indexOf('?') + 1));
  return storeId;
})();

export function loadDataProviderSettings(country, lang) {
  const version = window.location.href.split('cwcalc/').pop().split("/")[0];
  const isRunningInCTEF = window.location.href.includes('cte') || window.location.href.includes('local');
  const serviceSettings = {
    applicationId: "cwcalc",
    applicationVersion: version,
    platform: isKiosk ? 'kiosk' : 'owfe',
    countryCode: `${country}`,
    languageCode: `${lang}`,
    storeId: getStoreID,
    kiosk: isKiosk,
    isPlanner: true,
    enableGa: true,
    kioskId: getKioskID,
    // abVersion: "A", // optional
    dev: isRunningInCTEF, // optional, will default to false
  };
  return serviceSettings;
}

export function loadUpptackaSettings() {
  const isRunningInCTEF = window.location.href.includes('cte') || window.location.href.includes('local');
  const integration = new KioskIntegration({
    platform: "gallery", 
    // The upptäcka "settings", is only used for gallery integration for now, as Upptäcka never went live for CWTC.
    // all upptäcka references can be considered used for gallery integration.
    debug: isRunningInCTEF
  }
  );
  integration.applicationLoaded();
  return integration;
}


export default languageProviderReducer;
